export default __webpack_public_path__ + "static/media/5138.8afa9ce3.png";